exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input__wrapper input{width:95%}.input__wrapper input label{margin-right:5px}.input__wrapper{padding:5px}#editDictionaryModal .v--modal-box.v--modal{min-height:250px!important;min-width:450px!important}#description,#editDictionaryModal .v-text-field__slot input{font-size:12px}#description{padding-top:10px}#newSchemaInput,#newTableInput{margin-left:5px}.btn--editDict{position:absolute;bottom:10px;right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-531d754e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/dictionaries/EditDictionary.vue
// module id = 1920
// module chunks = 0